import { Navigate, useLocation } from "react-router-dom";
import { useLoginContext } from "src/contextApi/LoginContext";
import { Loader } from "src/components/layout";
import { ROUTE_CONSTANTS } from "./routeConstant";

interface AuthenticatedRouteProps {
  children: React.ReactNode;
}

const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ children }) => {
  const { isAuthenticated, isAuthenticating } = useLoginContext();
  const location = useLocation();

  if (isAuthenticating) {
    return <Loader height="h-screen" />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTE_CONSTANTS.LOGIN}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default AuthenticatedRoute;
